import { JsonLdResult, JsonLdResults } from 'vet-bones/utils';

import {
  STORED_QUERY_TAG_IRI,
  SYSTEM_QUERY_CREATOR_IRI,
  SYSTEM_QUERY_DATABASE_IRI,
  SYSTEM_QUERY_IRI,
  SYSTEM_QUERY_NAME_IRI,
  SYSTEM_QUERY_STRING_IRI,
  SYSTEM_QUERY_VOICEBOX_QUESTION_IRI,
  SYSTEM_REASONING_QUERY_IRI,
  SYSTEM_SHARED_QUERY_IRI,
  SYSTEM_STORED_QUERY_IRI,
} from 'src/common/constants/uris';
import { StoredQuery } from 'src/common/store/storedQueries/StoredQueriesState';

export const serializeStoredQuery = (
  storedQuery: StoredQuery
): JsonLdResults => {
  const serialized: JsonLdResult = {
    '@id': `${SYSTEM_QUERY_IRI}${storedQuery.name}`,
    '@type': [
      SYSTEM_STORED_QUERY_IRI,
      storedQuery.reasoning ? SYSTEM_REASONING_QUERY_IRI : '',
      storedQuery.shared ? SYSTEM_SHARED_QUERY_IRI : '',
    ].filter(Boolean),
  };

  Object.entries({
    [SYSTEM_QUERY_NAME_IRI]: storedQuery.name,
    [SYSTEM_QUERY_STRING_IRI]: storedQuery.query,
    [SYSTEM_QUERY_CREATOR_IRI]: storedQuery.creator,
    [SYSTEM_QUERY_DATABASE_IRI]: storedQuery.database,
  })
    .filter((entry): entry is [string, string] => Boolean(entry[1]))
    .forEach(([key, value]) => {
      serialized[key] = { '@value': value };
    });

  Object.entries({
    [SYSTEM_QUERY_VOICEBOX_QUESTION_IRI]: storedQuery.tags.voiceboxQuestions,
    [STORED_QUERY_TAG_IRI]: Array.from(storedQuery.tags.userTags),
  }).forEach(([key, values]) => {
    if (values && values.length) {
      serialized[key] = values?.map((value: string) => ({ '@value': value }));
    }
  });

  return {
    '@graph': [serialized],
  };
};
